import { OrganizationDashboard } from "@/features/organizations";
import { createFileRoute } from "@tanstack/react-router";
import { isomorphicHttpClient } from "../../../httpClient";
import { verifyRoles } from "../../../utils/verifyRoles";

export const Route = createFileRoute("/dashboard/organizations/")({
  component: OrganizationDashboard,
  head: () => ({
    meta: [{ title: "Organizações - Backoffice Detentora Iniciador" }],
  }),
  beforeLoad: () => verifyRoles(["INIC_ADMIN"]),
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.prefetchQuery({
        queryKey: ["organizations"],
        queryFn: async () => {
          const httpClient = isomorphicHttpClient();
          const { data, error } = await httpClient.GET("/v1/organizations");

          if (error) {
            throw new Error(error.message);
          }

          return data;
        },
      }),

      context.queryClient.prefetchQuery({
        queryKey: ["participants"],
        queryFn: async () => {
          const httpClient = isomorphicHttpClient();
          const { data, error } = await httpClient.GET("/v1/participants");

          if (error) {
            throw new Error(error.message);
          }

          return data;
        },
      }),
    ]);
  },
});
